import { useLang } from "../contexts/LangContext";

export default function Impressum() {
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#FF5A00] mb-3">RECHTLICHES</p>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter mb-10" data-testid="impressum-title">Impressum</h1>

        <p className="text-sm text-neutral-500 mb-10">Angaben gemäß § 5 TMG</p>

        <div className="mb-10 p-5 bg-amber-50 border-s-4 border-amber-500 text-sm text-amber-900 leading-relaxed">
          <p className="font-bold mb-1">Hinweis: Gesellschaft in Gründung</p>
          <p>
            Die Talkani Logistik &amp; Reinigung GmbH befindet sich derzeit in
            Gründung („i.&nbsp;Gr.&#8220;). Die Eintragung in das Handelsregister
            ist beantragt. Bis zur Eintragung haftet der Gründungsgesellschafter
            für Verbindlichkeiten der Gesellschaft persönlich und unbeschränkt
            (§&nbsp;11 Abs.&nbsp;2 GmbHG).
          </p>
        </div>

        <Section title="Anbieter">
          <p className="font-bold">Talkani Logistik &amp; Reinigung GmbH <span className="text-[#FF5A00] font-bold">i.&nbsp;Gr.</span></p>
          <p className="text-sm text-neutral-500">Logistik · Reinigung · Service</p>
          <p className="text-neutral-700 mt-2">Walddörferstraße 383</p>
          <p className="text-neutral-700">22047 Hamburg</p>
          <p className="text-neutral-700">Deutschland</p>
        </Section>

        <Section title="Vertreten durch">
          <p className="font-bold" data-testid="impressum-geschaeftsfuehrer">Ali Al-Talkani, Gründungsgesellschafter</p>
        </Section>

        <Section title="Kontakt">
          <p><span className="text-neutral-500 inline-block w-24">Telefon:</span> <a href="tel:+491758802646" className="font-semibold hover:text-[#FF5A00]">+49 175 8802646</a></p>
          <p className="mt-1"><span className="text-neutral-500 inline-block w-24">E-Mail:</span> <a href="mailto:info@talkani.de" className="font-semibold hover:text-[#FF5A00]">info@talkani.de</a></p>
        </Section>

        <Section title="Umsatzsteuer-ID">
          <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG:</p>
          <p className="font-mono font-bold mt-1 text-neutral-500 italic" data-testid="impressum-ustid">in Beantragung – wird nach Eintragung ergänzt</p>
        </Section>

        <Section title="Handelsregister">
          <p className="text-neutral-700">Zuständig: Amtsgericht Hamburg</p>
          <p className="text-neutral-600 mt-1">Eintragung im Handelsregister: <span className="italic">in Vorbereitung – HRB-Nummer wird nach Eintragung zeitnah ergänzt.</span></p>
        </Section>

        <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
          <p className="font-bold">Ali Al-Talkani</p>
        </Section>

        <Section title="Streitschlichtung">
          <p className="text-neutral-700 leading-relaxed">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" className="text-[#FF5A00] underline" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          <p className="text-neutral-700 leading-relaxed mt-3">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Section>

        <Section title="Haftung für Inhalte">
          <p className="text-neutral-700 leading-relaxed">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p className="text-neutral-700 leading-relaxed">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500 mb-3">{title}</h2>
      <div className="text-base text-neutral-800 leading-relaxed">{children}</div>
    </section>
  );
}
